<template>
  <div class="logout" @click="logout">注销账号</div>
</template>

<script>
import { getLogout } from "@api/user";
import { clearAuthStatus } from "@libs/wechat";
import cookie from "@utils/store/localStorage";
export default {
  data() {
    return {};
  },
  methods: {
    logout() {
      this.$dialog.confirm({
        mes: "确认注销账号?",
        opts: () => {
          this.$dialog.toast({ mes: "操作成功，请等待审核" });
          setTimeout(() => {
            getLogout()
              .then(res => {
                this.$store.commit("LOGOUT");
                clearAuthStatus();
                cookie.remove("spread");
                location.href = location.origin;
                console.log(res);
              })
              .catch(err => {
                console.log(err);
              });
          }, 1000);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.logout {
  width: 90%;
  height: 0.8rem;
  margin-top: 2rem;
  border-radius: 0.4rem;
  margin-left: 5%;
  background-color: #0e98fd;
  color: #fff;
  font-size: 0.36rem;
  text-align: center;
  line-height: 0.8rem;
}
</style>
